<div id="{{dialogId}}" appDraggable dragTarget="#{{dialogId}}" dragHandle="#{{this.getIdForDialogHeader()}}"
     class="modal fade locationAlertDataPane in ui-draggable ui-draggable-handle" style="width: auto; min-width: 450px; max-width: 600px; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
     [class.modalInsideModal]="popupInModal == true"
     role="dialog">
	<div class="modal-dialog-sm" role="document">
		<div class="modal-content">
			<div id="{{this.getIdForDialogHeader()}}" class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
					<span aria-hidden="true">x</span>
				</button>
				<h4 class="modal-title">
					<span><img [src]="getPathForPersonIcon()" /> PERSON</span>
					<div style="float: right; padding-right: 40px">{{person.name}}</div>
				</h4>
			</div>
			<div class="modal-body">
				<div class="row">
					<div class="col-sm-3">
						<div>
							<img [src]="getPathForPersonImage()" width="80">
						</div>
						<div></div>
					</div>
					<div class="col-sm-9">
            <ng-container *ngIf="this.mainDisplayParameters">
              <ng-container *ngFor="let mainDisplayParameter of this.mainDisplayParameters">
                <div class="row">
                  <div class="col-sm-3">{{ mainDisplayParameter.name }}</div>
                  <div class="col-sm-9">{{ mainDisplayParameter.value }}</div>
                </div>
              </ng-container>
            </ng-container>
						<div class="row">
							<div class="col-sm-12"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
